var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ProjectManager extends Component {
    constructor() {
        super('ProjectManager', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.project').each((element) => {
                ProjectManager.projects[parseInt(element.attr('id').replace('project-', ''))] = new Project(element);
            });
            $('.btn-toggle-project-informations, .slide-caption').on('click', (event, button) => {
                event.preventDefault();
                this.toggleProjectInformations(button.parents('.project'));
            });
            // Set up click event to navigate slides
            $('.slide-image').on('click', (event, slideImage) => {
                this.openProjectInformations(slideImage.parents('.project'));
            });
            $('.btn-back-to-project').on('click', (event) => {
                event.preventDefault();
                if ($('body').hasClass('home'))
                    return;
                sessionStorage.setItem('targetProjectId', $(event.currentTarget).data('projectId'));
                sessionStorage.setItem('targetSlideIndex', $(event.currentTarget).data('slideIndex'));
                window.location.href = '/';
            });
            $(window).on('keydown', (event) => {
                if (['ArrowLeft', 'ArrowRight'].includes(event.key))
                    event.preventDefault();
                ;
                if (event.key === 'ArrowLeft')
                    ProjectManager.projects[ProjectManager.currentProjectId].prevSlide();
                if (event.key === 'ArrowRight')
                    ProjectManager.projects[ProjectManager.currentProjectId].nextSlide();
            });
            $('.btn-prev-slide, .btn-next-slide').on('mouseenter', (event, button) => {
                const project = ProjectManager.projects[ProjectManager.currentProjectId];
                if (project.slideIndex == 0 && button.hasClass('btn-prev-slide'))
                    return;
                const target = button.hasClass('btn-next-slide') ? '.icon-next-slide' : '.icon-prev-slide';
                button.parents('.project').find(target).addClass('is-visible');
            }).on('mouseleave', (event, button) => {
                button.parents('.project').find('.icon-prev-slide, .icon-next-slide').removeClass('is-visible');
            }).on('click', (event, button) => {
                event.preventDefault();
                const project = ProjectManager.projects[ProjectManager.currentProjectId];
                if (button.hasClass('btn-next-slide'))
                    project.nextSlide();
                if (button.hasClass('btn-prev-slide'))
                    project.prevSlide();
            });
            if (!$('body').hasClass('home'))
                ProjectManager.currentProjectId = parseInt($('.project').attr('id').replace('project-', ''));
            $(window).on('resize', () => {
                ProjectManager.updateMobileCaptionTop();
            });
            setTimeout(() => {
                ProjectManager.updateMobileCaptionTop();
                ProjectManager.fixMobileImageHeight();
            }, 100);
            ProjectManager.fixMobileImageHeight();
            this.success();
        });
    }
    /*
     * Fix mobile image height
     */
    static fixMobileImageHeight() {
        if ($(window).width() <= 992) {
            const mobileImageHeight = ($(window).width() - 40) * 1.33;
            const padding = ($(window).height() - mobileImageHeight) / 2;
            $('.project').css({
                '--mobile-image-height': `${mobileImageHeight}px`,
                '--padding-y': `${padding}px`
            });
        }
    }
    /*
     * Hard fix fot fucked up mobile browsers
     */
    static updateMobileCaptionTop() {
        const mobileCaptionTop = parseFloat($('.slide').css('padding-top').replace(/px/gi, '')) + $('.slide-image').height() + 8;
        $('.project').css('--mobile-caption-top', mobileCaptionTop + 'px');
    }
    toggleProjectInformations(project) {
        if (project.find('.project-informations').hasClass('d-none')) {
            this.openProjectInformations(project);
        }
        else {
            ProjectManager.closeProjectInformations();
        }
    }
    openProjectInformations(project) {
        project.find('.project-informations').removeClass('d-none');
        $('.btn-toggle-menu').addClass('is-active').data('action', 'close-project-informations');
        $('.slide-counter').addClass('d-none');
    }
    static closeProjectInformations() {
        $('.project-informations').addClass('d-none');
        $('.btn-toggle-menu').removeClass('is-active').data('action', 'default');
        $('.slide-counter').removeClass('d-none');
    }
}
ProjectManager.projects = {};
class Project {
    constructor(element) {
        this.slideIndex = 0;
        this.element = element;
        this.container = this.element.find('.slide-container');
        this.slides = this.element.find('.slide');
        this.counter = this.element.find('.slide-counter .current');
        this.separator = this.element.find('.slide-counter .separator-path');
        // Set up Intersection Observer to manage slide counter
        const slideContainerElement = this.container.get(0);
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const index = Math.round(slideContainerElement.scrollLeft / window.innerWidth);
                    this.slideIndex = index;
                    this.counter.text((this.slideIndex + 1).toString());
                }
            });
        }, {
            root: slideContainerElement,
            threshold: 0.5
        });
        this.slides.each((slide) => {
            observer.observe(slide.get(0));
        });
        // Set up scroll observer for updating .slide-counter .separator rotation
        this.container.on('scroll', () => {
            let rotation = slideContainerElement.scrollLeft / window.innerWidth * 180;
            this.separator.css('--rotation', `${rotation}deg`);
            rotation = Math.floor(rotation);
        });
        let isScrolling = false;
        this.container.on('touchmove', () => {
            if (isScrolling)
                return;
            this.element.find('.slide-caption').removeClass('is-visible');
            isScrolling = true;
        }).on('touchend', () => {
            setTimeout(() => {
                this.element.find('.slide-caption').addClass('is-visible');
                isScrolling = false;
            }, 300);
        });
    }
    prevSlide() {
        if (this.slideIndex == 0)
            return;
        this.slideIndex = (this.slideIndex - 1 + this.slides.length) % this.slides.length;
        this.container.get(0).scrollTo({
            left: this.slideIndex * window.innerWidth,
            behavior: 'smooth'
        });
    }
    nextSlide() {
        this.slideIndex = (this.slideIndex + 1) % this.slides.length;
        this.container.get(0).scrollTo({
            left: this.slideIndex * window.innerWidth,
            behavior: 'smooth'
        });
    }
    jumpTo(slideIndex, behavior = 'auto') {
        this.slideIndex = slideIndex;
        this.container.get(0).scrollTo({
            left: this.slideIndex * window.innerWidth,
            behavior: behavior
        });
    }
}
